import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization } from "./fetch";

export const findAllCurrencies = async (page = 1, limit = 5, params) => {
  const { condominium_id } = params;
  try {
    const url = `/currency?condominium_id=${condominium_id}&page=${page}&limit=${limit}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar las monedas."
    );
  }
};

export const findAllExchangeRates = async (page = 1, limit = 5, params) => {
  const { currency } = params;
  if (currency) {
    try {
      const url = `/currency/exchange/${currency}?page=${page}&limit=${limit}`;
      const data = await fetchWithAuthorization(url);
      return data;
    } catch (error) {
      throw new FetchError(
        error,
        "Ha ocurrido un error al consultar las tasas de cambio."
      );
    }
  } else {
    throw new FetchError(null, "Debes seleccionar una moneda.");
  }
};

export const showCurrency = async (params) => {
  const { condominium_id, start_date, end_date } = params;
  try {
    const url = `/currency/exchange?condominium_id=${condominium_id}&start_date=${start_date}&end_date=${end_date}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar las monedas."
    );
  }
};

export const fetchDayRate = async (params = {}) => {
  const { condominium_id, date } = params;
  const query = new URLSearchParams();
  if (condominium_id) query.append("condominium_id", String(condominium_id));
  if (date) query.append("date", String(date));
  const queryString = query.toString();
  try {
    const data = await fetchWithAuthorization(
      `/currency/exchange/day-rate${queryString ? `?${queryString}` : ""}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "No se pudo obtener la tasa del día.");
  }
};

export const fetchLiveExchangeRate = async (params) => {
  const { condominium_id, date } = params;
  try {
    const dateParam = date ? `&date=${date}` : "";
    const url = `/currency/exchange/live?condominium_id=${condominium_id}${dateParam}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "No se pudo obtener la tasa oficial en este momento."
    );
  }
};

export const createExchangeRate = async (params) => {
  const { currency, exchangeRate } = params;
  try {
    const url = `/currency/exchange/${currency}`;
    const data = await fetchWithAuthorization(url, exchangeRate, "POST");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al consultar los abonos."
    );
  }
};

export const createCurrency = async (params) => {
  const { currency } = params;
  try {
    const url = "/currency";
    const data = await fetchWithAuthorization(url, currency, "POST");
    return data;
  } catch (error) {
    throw new FetchError(error, "Ha ocurrido un error al crear la moneda.");
  }
};

export const updateCurrency = async (params) => {
  const { currency, id } = params;
  try {
    const url = `/currency/${id}`;
    const data = await fetchWithAuthorization(url, currency, "PUT");
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al actualizar la moneda."
    );
  }
};
